import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { ROUTE_AUTH_LOGIN } from '../util/constants';

interface RequireLoggedInProps {
  children: JSX.Element;
  /**
   * Where a signed-out visitor goes when they open exactly this route's own
   * path (not a deep link under it). /fleet uses it: someone typing
   * book.aperiomobility.com/fleet is a new fleet, so they get the free fleet
   * sign-up, which links to log in (owner, 2026-11-04). Deep links from
   * emails still go to log in and come back.
   */
  signedOutRoot?: { path: string; to: string };
}

export default function RequireLoggedIn({
  children,
  signedOutRoot,
}: RequireLoggedInProps) {
  const isAuthenticated = useAppSelector((state) => (
    state.auth.isAuthenticated
  ));

  const location = useLocation();

  if (!isAuthenticated) {
    if (signedOutRoot
      && location.pathname.replace(/\/+$/, '') === signedOutRoot.path) {
      return <Navigate to={signedOutRoot.to + location.search} replace />;
    }
    return <Navigate to={ROUTE_AUTH_LOGIN} state={{ from: location }} />;
  }

  return children;
}
